<script setup lang="ts">
   import { definePageMeta, useHead } from '#imports';

   definePageMeta({
      layout: 'wow-polo',
   });

   useHead({
      title: 'Our Partners — WOW Polo Series',
   });
</script>

<template>
   <div>
      <!-- Hero -->
      <section class="wow-partners-hero relative h-[320px] bg-cover bg-center bg-no-repeat">
         <div class="absolute inset-0 bg-black/50" />
         <div class="relative flex h-full flex-col items-center justify-center px-6 text-center">
            <h1 class="mb-4 text-4xl font-bold text-white md:text-5xl lg:text-6xl">
               Our Partners
            </h1>
            <p class="max-w-xl text-lg text-white/90">
               Proudly supported by our partners
            </p>
         </div>
      </section>

      <!-- Partners Grid -->
      <section class="bg-white py-16">
         <WowPoloPartners />
      </section>
   </div>
</template>

<style scoped>
   .wow-partners-hero {
      background-image: url('/img/home-page-hero-bg.webp');
   }
</style>
